import React from 'react';

interface Props extends React.HTMLProps<HTMLButtonElement> {
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
}

/**
 * Returns an instance of ButtonBase.
 *
 * @param children - Contents of the button.
 * @param onClick - The callback handler for the click event.
 * @param type - Type property. Must be `button`, `reset`, or `submit`.
 * @param props - Remaining props to be passed to button.
 *
 * @example
 *
 * ```typescriptreact
 * <ButtonBase
 *  onClick={() => {}}
 *  type={button}
 *  >
 *   Example Text
 * </ButtonBase>
 * ```
 */
export default function ButtonBase({ children, onClick, type = 'button', ...props }: Props) {
  return (
    <button onClick={onClick} type={type} {...props}>
      {children}
    </button>
  );
}
